
import { createContext, ReactNode } from 'react';

export type AlertSeverity = "success" | "info" | "warning" | "error";

export interface IAlert {
    content: ReactNode;
    timeout?: number;
    severity?: AlertSeverity;
    dismissable?: boolean;
}

export interface IAlertContext {
    alerts: IAlert[],
    addAlert: (alert: IAlert) => void;
}

const AlertContext = createContext<IAlertContext>({
    alerts: [],
    addAlert: () => {}
});

export default AlertContext;
